export const QUERY_KEYS = {
    GET_SESSION: 'get-session',
    GET_PATIENTS: 'get-patients'
} as const

export const MUTATION_KEYS = {
    VALIDATE_SESSION: 'validate-session',
    SEND_PATIENT: 'send-patient'
} as const
